import { ReactElement, ReactNode } from 'react';
import { Text } from '@coverflex-tech/hypernova';
import css from './detail-list.module.css';

interface IDetailListItemProps {
  label: ReactNode;
  value: ReactNode;
  isValueStrikethrough?: boolean;
}

interface IDetailListProps {
  title: string;
  description?: ReactElement;
  children:
    | ReactElement<IDetailListItemProps>
    | (ReactElement<IDetailListItemProps> | null | undefined)[]
    | null;
  className?: string;
}

export const DetailListItem = ({
  label,
  value,
  isValueStrikethrough = false,
}: IDetailListItemProps) => (
  <div className={css.item}>
    <Text>{label}</Text>
    <Text
      bold={!isValueStrikethrough}
      strikethrough={isValueStrikethrough}
      className={css.value}
    >
      {value}
    </Text>
  </div>
);

export const DetailList = ({
  title,
  children,
  description,
  className,
}: IDetailListProps) => {
  return (
    <div className={className}>
      <Text className={css.title} bold size="sm">
        {title}
      </Text>
      {description && description}
      {children}
    </div>
  );
};

export default DetailList;
